import { createAction, props } from "@ngrx/store";
import { ICapability } from "@skills-app/models/capability";
import { ISkillGroup } from "@skills-app/models/skillGroup";
import { ISkillNode } from "@skills-app/models/skillNode";
import { ThingSpaceType } from "@skills-app/models/thingspaceGraph";

const prefix = "[Skill Group API]";

export const requestSkillGroupByName = createAction(
  `${prefix} Request Skill Group`,
  props<{ skillGroupName: string; includeSkills: boolean }>(),
);

export const requestSkillGroupByNameSuccess = createAction(
  `${prefix} Request Skill Group Success`,
  props<{ skillGroup: ISkillGroup }>(),
);

export const requestSkillGroupError = createAction(
  `${prefix} Request Skill Group Error`,
);

export const deleteSkillGroup = createAction(
  `${prefix} Delete Skill Group Request`,
  props<{ skillGroupId: string }>(),
);

export const deleteSkillGroupSuccess = createAction(
  `${prefix} Delete Skill Group Success`,
);

export const deleteSkillGroupError = createAction(
  `${prefix} Delete Skill Group Error`,
);

export const upsertSkillGroup = createAction(
  `${prefix} Request Upsert Skill Group`,
  props<{ skillGroup: ISkillGroup }>(),
);

export const upsertSkillGroupSuccess = createAction(
  `${prefix} Request Upsert Skill Group Success`,
  props<{ skillGroup: ISkillGroup }>(),
);

export const upsertSkillGroupError = createAction(
  `${prefix} Request Upsert Skill Group Error`,
);

export const requestSkillGroupById = createAction(
  `${prefix} Request Skill Group By Id`,
  props<{
    skillGroupId: string;
    includeSkills: boolean;
    includeCapabilties: boolean;
  }>(),
);

export const requestSkillGroupByIdSuccess = createAction(
  `${prefix} Request Skill Group By Id Success`,
  props<{ skillGroup: ISkillGroup }>(),
);

export const requestSkillGroupByIdError = createAction(
  `${prefix} Request Skill Group By Id Error`,
);

export const linkToCapability = createAction(
  `${prefix} Request Link to Capability`,
  props<{ skillGroup: ISkillGroup; capability: ICapability }>(),
);

export const linkToCapabilitySuccess = createAction(
  `${prefix} Request Link to Capability Success`,
);

export const linkToCapabilityError = createAction(
  `${prefix} Request Link to Capability Error`,
);

export const deleteCapabilityLinks = createAction(
  `${prefix} Delete Link to Capability`,
  props<{ skillGroup: ISkillGroup; capability: ICapability }>(),
);

export const deleteCapabilityLinksSuccess = createAction(
  `${prefix} Delete Link to Capability Success`,
);

export const deleteCapabilityLinksError = createAction(
  `${prefix} Delete Link to Capability Error`,
);

export const getSkillGroups = createAction(
  `${prefix} Request all skill groups`,
);

export const getSkillGroupsSuccess = createAction(
  `${prefix} Request all skill groups Success`,
  props<{ skillGroups: ISkillGroup[] }>(),
);

export const getSkillGroupsError = createAction(
  `${prefix} Request all skill groups Error`,
);

export const getSkillGroupForType = createAction(
  `${prefix} Request all skill groups for type`,
  props<{ thingSpaceType: ThingSpaceType }>(),
);

export const getSkillGroupsForTypeSuccess = createAction(
  `${prefix} Request all skill groups for type Success`,
  props<{ skillGroups: ISkillGroup[] }>(),
);

export const getSkillGroupsForTypeError = createAction(
  `${prefix} Request all skill groups for type Error`,
);

export const skillGroupsForSkillNodeRequest = createAction(
  `${prefix} Get Skill Groups for Skill Nodes Request`,
  props<{ skill: ISkillNode }>(),
);

export const skillGroupsForSkillNodeSuccess = createAction(
  `${prefix} Get Skill Groups for Skill Nodes Success`,
  props<{ skillGroups: ISkillGroup[] }>(),
);

export const skillGroupsForSkillNodeError = createAction(
  `${prefix} Get Skill Groups for Skill Nodes Error`,
);
